import ApplicationsStore, {
  initialApplicationsStoreValues,
} from './applications-store';
import { extractApplications } from '../utils/application-utils';
import { AppPages, navigate } from '../../common/routing/app-navigator';
import { loadSingleApplication } from '../actions/single-application-actions';
import { ApplicationInfo, BaseApplicationRow } from '../applications-types';
import { ChangeEvent } from 'react';
import { snapshot } from 'valtio';

export const setApplications = (
  applications: BaseApplicationRow[],
  update?: boolean,
) => {
  if (applications) {
    const formatted = extractApplications(applications);
    if (update) {
      ApplicationsStore.applications = formatted;
    } else {
      ApplicationsStore.applications?.push(...formatted);
    }
  }
};

export const setApplicationsOffset = (offset: number = 0) => {
  ApplicationsStore.offset = offset;
};

export const setApplicationsTotal = (total: number) => {
  ApplicationsStore.total = total;
};

export const setIrrelevantApplicationsTotal = (totalIrrelevantApps: number) => {
  ApplicationsStore.totalIrrelevantApps = totalIrrelevantApps;
};

export const setSearchValue = (searchValue: string) => {
  ApplicationsStore.appFilterValue = searchValue;
};

export const selectApplication = (id: string) => {
  const { selectedAppId } = snapshot(ApplicationsStore);
  if (selectedAppId !== id) {
    ApplicationsStore.selectedAppId = id;
    //TODO: Calling with cache false temoprary soultion
    // until Alex refactor of loadSingleApplication
    loadSingleApplication({
      cache: false,
    });
    navigate(AppPages.Applications, `appId=${encodeURIComponent(id)}`);
  }
};

export const clearSelectedApplication = () => {
  ApplicationsStore.selectedAppId = null;
  ApplicationsStore.selectedApp = undefined;
};

export const clearSelectedApps = () => {
  const { selected } = snapshot(ApplicationsStore);
  const temp = {};
  Object.keys(selected).forEach(key => (temp[key] = false));
  ApplicationsStore.selected = temp;
};

export const setApplication = (application: ApplicationInfo) => {
  ApplicationsStore.selectedApp = application;
};

export const setLoadingSingleApp = (value: boolean) => {
  ApplicationsStore.loadingSingleApp = value;
};

export const setLastDrawerHeight = (height: number) => {
  ApplicationsStore.lastDrawerHeight = height;
};

export const clearStore = () => {
  Object.keys(initialApplicationsStoreValues).forEach(key => {
    ApplicationsStore[key] = initialApplicationsStoreValues[key];
  });
};

export const toggleFiltersPanel = () => {
  ApplicationsStore.filtersOpen = !ApplicationsStore.filtersOpen;
};

export const setExclusionComment = (e: ChangeEvent<HTMLTextAreaElement>) => {
  ApplicationsStore.applications?.forEach(app => {
    if (ApplicationsStore.selected[app.appId]) {
      app.exclusionComment = e.target.value;
    }
  });
};

export const toggleAllSelected = () => {
  const { selected, allSelected, applications } = snapshot(ApplicationsStore);
  const fakeApps = applications
    ?.filter(app => app.fakeApp === true)
    .map(app => app.appName);
  const temp = {};
  const keys = Object.keys(selected);
  const keysFilter = keys.filter(key => !fakeApps?.includes(key));

  keysFilter.forEach(id => (temp[id] = !allSelected));

  ApplicationsStore.selected = temp;
};
